import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { speakerStyles } from "../../../../utils/speakerStyle";

function SpeakerIndicator(props: any) {
  const speakers = useSelector((state: RootState) => state.qCDetailPageState.data.transcriptions[0].speakers) as string[];
  return (
    <div className="d-flex gap-2">
      {speakers.map((speaker, index) => (
        <div className="d-flex align-items-center gap-2">
          <div
            key={index}
            className="speaker-indicator"
            style={{
              backgroundColor: speakerStyles[index].color,
              color: speakerStyles[index].color,
              width: 30,
              height: 5,

              margin: "2px 0",
            }}
          />
          <span
            style={{
              fontSize: 12,
            }}>
            {speaker}
          </span>
        </div>
      ))}
    </div>
  );
}

export default SpeakerIndicator;
